// The table's row groups (ActivityTable's `groups`, P10 of documentation/pr-plans/insights-simplify-plan.md:
// Win back clicks' reasons). A table with groups lists every group's rows together, in the order the
// groups were sent, and each row keeps the place the sort gave it inside its group; a heading names the
// group above its first row on each page. A table without groups is untouched.
export default function groupsPart() {
    return {
        hasGroups() {
            return Array.isArray(this.table.groups) && this.table.groups.length > 0;
        },

        // The rows, sorted, grouped in the groups' order. Array.prototype.sort is stable, so within a group
        // the rows keep the order the sort (or, with none, the activity) gave them.
        groupRows(rows) {
            if (!this.hasGroups()) {
                return rows;
            }

            const place = {};

            this.table.groups.forEach((group, index) => {
                place[group.key] = index;
            });

            return rows.slice().sort((a, b) => (place[a.group] ?? this.table.groups.length) - (place[b.group] ?? this.table.groups.length));
        },

        // The group whose heading the row at `index` of the page draws above it: the page's first row, and
        // every row whose group is not the one above it. A group that runs onto the next page is named
        // again at its top, so no page starts with rows under no heading. Null for every other row.
        groupHeadAt(index) {
            const row = this.visibleRows[index];

            if (!this.hasGroups() || !row || (index > 0 && this.visibleRows[index - 1]?.group === row.group)) {
                return null;
            }

            return this.table.groups.find((group) => group.key === row.group) ?? null;
        },
    };
}
